import { Component, inject, InjectFlags } from '@angular/core';
import { Router } from '@angular/router';
import { MwcModalService, NZ_MODAL_DATA } from 'mwc/modal';
import { AIWaitingInfo } from 'src/app/_shared/models/topic';
import { GenerationInProgressHelperService } from '../../../../services/helper/generation-in-progress-popup/generation-in-progress-popup-helper.service';

@Component({
  selector: 'app-generation-in-progress-popup',
  templateUrl: './generation-in-progress-popup.component.html',
  styleUrls: ['./generation-in-progress-popup.component.scss']
})
export class GenerationInProgressPopupComponent {
  readonly mwcModalData: { sliderData: AIWaitingInfo[], textTitle: string, isForCampaignGenerationIdeas: boolean, isForBulkMeta:boolean } = inject(NZ_MODAL_DATA, InjectFlags.Optional);


  sliderData:AIWaitingInfo[] = this.mwcModalData?.sliderData ? this.mwcModalData.sliderData : [];
  textTitle = this.mwcModalData?.textTitle ? this.mwcModalData.textTitle : "";
  isForCampaignGenerationIdeas: boolean = false;
  isForBulkMeta: boolean = false;

  activeSlideIndex = 0;
  selectedObjects:AIWaitingInfo[] = [];

  constructor(
    private modalService: MwcModalService,
    private router: Router,
    private generationInProgressHelperService: GenerationInProgressHelperService
  ){}
  
  ngAfterViewInit(){
    console.log(this.sliderData);
  }
  ngOnInit(){
    this.isForCampaignGenerationIdeas = this.mwcModalData.isForCampaignGenerationIdeas;
    this.isForBulkMeta = this.mwcModalData.isForBulkMeta; 
  }

  goToDashboard() {
    this.router.navigateByUrl("/dashboard");
    this.generationInProgressHelperService.closeTemplateSelector();
  }
}
